/** "claude-opus-5-5" → "Opus 5.5", "claude-sonnet-5" → "Sonnet 5". Unrecognized ids pass through. */
export function modelLabel(id: string): string {
  // Dated snapshots ("claude-haiku-4-5-20251001") name the same model.
  const match = /^claude-([a-z]+)-(\d+(?:-\d+)?)(?:-\d{8})?$/.exec(id)
  if (!match) return id
  const [, family, version] = match
  return `${family![0]!.toUpperCase()}${family!.slice(1)} ${version!.replace('-', '.')}`
}
